export const monthsFull = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
export const monthsShort = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

export const days = [
  {
    micro: 'S',
    short: 'Sun',
    full: 'Sunday'
  },
  {
    micro: 'M',
    short: 'Mon',
    full: 'Monday'
  },
  {
    micro: 'T',
    short: 'Tue',
    full: 'Tuesday'
  },
  {
    micro: 'W',
    short: 'Wed',
    full: 'Wednesday'
  },
  {
    micro: 'T',
    short: 'Thu',
    full: 'Thursday'
  },
  {
    micro: 'F',
    short: 'Fri',
    full: 'Friday'
  },
  {
    micro: 'S',
    short: 'Sat',
    full: 'Saturday'
  }
];
